import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class ExitFullFinalSettlementRecords extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_exit_and_fulland_final_settlement_records');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'resignation_letter')}><i class="fas fa-file-download"></i> KRAs &amp; KPIs Assigned</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'relieving_and_experience_letter')}><i class="fas fa-file-download"></i> Performance Reviews &amp; Ratings</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'full_final_settlement_report')}><i class="fas fa-file-download"></i> Promotion &amp; Salary Revision History</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'asset_return_confirmation')}><i class="fas fa-file-download"></i> Promotion &amp; Salary Revision History</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'non_competeand_non_solicitation_agreements')}><i class="fas fa-file-download"></i> Promotion &amp; Salary Revision History</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_exit_and_fulland_final_settlement_records';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#old_resignation_letter').val(data['resignation_letter_new_name']);
    $('#old_relieving_and_experience_letter').val(data['relieving_and_experience_letter_new_name']);
    $('#old_full_final_settlement_report').val(data['full_final_settlement_report_new_name']);
    $('#old_asset_return_confirmation').val(data['asset_return_confirmation_new_name']);
    $('#old_non_competeand_non_solicitation_agreements').val(data['non_competeand_non_solicitation_agreements_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());


    var resignation_letter_temp    = window.isNullAndUndef($('#resignation_letter').val());
    var org_resignation_letter     = $("#resignation_letter").prop("files")[0];
    var resignation_letter_name    = $('#resignation_letter').val().split('\\').pop();

    var relieving_and_experience_letter_temp        = window.isNullAndUndef($('#relieving_and_experience_letter').val());
    var org_relieving_and_experience_letter         = $("#relieving_and_experience_letter").prop("files")[0];
    var relieving_and_experience_letter_name        = $('#relieving_and_experience_letter').val().split('\\').pop();

    var full_final_settlement_report_temp        = window.isNullAndUndef($('#full_final_settlement_report').val());
    var org_full_final_settlement_report         = $("#full_final_settlement_report").prop("files")[0];
    var full_final_settlement_report_name        = $('#full_final_settlement_report').val().split('\\').pop();

    var asset_return_confirmation_temp        = window.isNullAndUndef($('#asset_return_confirmation').val());
    var org_asset_return_confirmation         = $("#asset_return_confirmation").prop("files")[0];
    var asset_return_confirmation_name        = $('#asset_return_confirmation').val().split('\\').pop();

    var non_competeand_non_solicitation_agreements_temp        = window.isNullAndUndef($('#non_competeand_non_solicitation_agreements').val());
    var org_non_competeand_non_solicitation_agreements         = $("#non_competeand_non_solicitation_agreements").prop("files")[0];
    var non_competeand_non_solicitation_agreements_name        = $('#non_competeand_non_solicitation_agreements').val().split('\\').pop();


    var resignation_letter_ext    = '';
    var relieving_and_experience_letter_ext         = '';
    var full_final_settlement_report_ext         = '';
    var asset_return_confirmation_ext         = '';
    var non_competeand_non_solicitation_agreements_ext         = '';

    if(resignation_letter_temp && relieving_and_experience_letter_temp && full_final_settlement_report_temp && asset_return_confirmation_temp && non_competeand_non_solicitation_agreements_temp){
      resignation_letter_ext       = resignation_letter_temp.split('.').pop();
      relieving_and_experience_letter_ext        = relieving_and_experience_letter_temp.split('.').pop();
      full_final_settlement_report_ext        = full_final_settlement_report_temp.split('.').pop();
      asset_return_confirmation_ext        = asset_return_confirmation_temp.split('.').pop();
      non_competeand_non_solicitation_agreements_ext        = non_competeand_non_solicitation_agreements_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(file_main_ext.indexOf(resignation_letter_ext) >= 0 && file_main_ext.indexOf(relieving_and_experience_letter_ext) >= 0 && file_main_ext.indexOf(full_final_settlement_report_ext) >= 0 && file_main_ext.indexOf(asset_return_confirmation_ext) >= 0 && file_main_ext.indexOf(non_competeand_non_solicitation_agreements_ext) >= 0){
      var old_resignation_letter                            = $('#old_resignation_letter').val();
      var old_relieving_and_experience_letter               = $('#old_relieving_and_experience_letter').val();
      var old_full_final_settlement_report                  = $('#old_full_final_settlement_report').val();
      var old_asset_return_confirmation                                  = $('#old_asset_return_confirmation').val();
      var old_non_competeand_non_solicitation_agreements    = $('#old_non_competeand_non_solicitation_agreements').val();
      var all_data                                          = {};


      all_data['resignation_letter']                        = window.return_false_null(resignation_letter_name);
      all_data['relieving_and_experience_letter']           = window.return_false_null(relieving_and_experience_letter_name);
      all_data['full_final_settlement_report']              = window.return_false_null(full_final_settlement_report_name);
      all_data['asset_return_confirmation']                              = window.return_false_null(asset_return_confirmation_name);
      all_data['non_competeand_non_solicitation_agreements']= window.return_false_null(non_competeand_non_solicitation_agreements_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('resignation_letter',org_resignation_letter);
      body.append('old_resignation_letter',old_resignation_letter);
      body.append('relieving_and_experience_letter',org_relieving_and_experience_letter);
      body.append('old_relieving_and_experience_letter',old_relieving_and_experience_letter);
      body.append('full_final_settlement_report',org_full_final_settlement_report);
      body.append('old_full_final_settlement_report',old_full_final_settlement_report);
      body.append('asset_return_confirmation',org_asset_return_confirmation);
      body.append('old_asset_return_confirmation',old_asset_return_confirmation);
      body.append('non_competeand_non_solicitation_agreements',org_non_competeand_non_solicitation_agreements);
      body.append('old_non_competeand_non_solicitation_agreements',old_non_competeand_non_solicitation_agreements);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_exit_and_fulland_final_settlement_records');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('resignation_letter','relieving_and_experience_letter','full_final_settlement_report','asset_return_confirmation','non_competeand_non_solicitation_agreements');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_resignation_letter" placeholder=""/>
                                        <input type="file" className="form-control" id="resignation_letter" placeholder="Resignation Letter"/>
                                        <label for="name">Resignation Letter</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_relieving_and_experience_letter" placeholder=""/>
                                        <input type="file" className="form-control" id="relieving_and_experience_letter" placeholder="Relieving &amp; Experience Letter"/>
                                        <label for="name">Relieving &amp; Experience Letter</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_full_final_settlement_report" placeholder=""/>
                                        <input type="file" className="form-control" id="full_final_settlement_report" placeholder="Full &amp; Final Settlement Report"/>
                                        <label for="name">Full &amp; Final Settlement Report</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_asset_return_confirmation" placeholder=""/>
                                        <input type="file" className="form-control" id="asset_return_confirmation" placeholder="Asset Return Confirmation (Laptop, ID Card, etc.)"/>
                                        <label for="name">Asset Return Confirmation (Laptop, ID Card, etc.)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_non_competeand_non_solicitation_agreements" placeholder=""/>
                                        <input type="file" className="form-control" id="non_competeand_non_solicitation_agreements" placeholder="Non-Compete &amp; Non-Solicitation Agreements"/>
                                        <label for="name">Non-Compete &amp; Non-Solicitation Agreements</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}



                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default ExitFullFinalSettlementRecords;
